import 'firebase/auth';
import axios from '@/axios';

export default {
  fetchBasicUsers(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchBasicUsersUrl =
        '/api/v1/basic-users/basic-user-list?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        encodeURIComponent(data.search)  +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&filter=' +
        data.filter +
        '&activeClinicId=' +
        data.activeClinicId;
      axios
        .get(fetchBasicUsersUrl)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchBasicUserDetails(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/basic-users/basic-user/' + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchBasicUserOrganizations(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/basic-users/organizations/' + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateBasicUserDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/basic-users/basic-user/' + data.id, data.data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateBasicUserIsSupplier(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v1/basic-users/is-supplier/'+ data.id, {
            isSupplier : data.isSupplier,
        } )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resetBasicUserPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/basic-users/userManagement/basic-user/' +
            data.id +
            '/resetPassword',
            data.data
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  createBasicUser(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/basic-users/register', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  exportCsv(_context, data) {
    return new Promise((resolve, reject) => {
      // Encode special characters in the query to make it safe for URLs and prevent breaking the API request
      const encodedSearchQuery = encodeURIComponent(data.search);
      axios
        .post(
          '/api/v1/basic-users/export-csv?page=' + data.page +
          '&limit=' + data.limit +
          '&exportMode=' + data.exportMode +
          '&clinicId=' + data.clinicId +
          '&search=' + encodedSearchQuery +
          '&filter=' + data.filter
        )
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
};
